<template>
  <div class="flex items-center justify-center">
    <div
      class="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"
    ></div>
  </div>
</template>

<script>
export default {
  name: "Loader"
}
</script>